import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=170d8380&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"
import style0 from "./Events.vue?vue&type=style&index=0&id=170d8380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170d8380",
  null
  
)

export default component.exports